import React, { useEffect, useState } from "react";
import { MapPin, Copy, ExternalLink, Navigation, Pencil, Check, X } from "lucide-react";
import { toast } from "sonner";

const dms = (v, pos, neg) => {
  const tenths = Math.round(Math.abs(v) * 36000);
  const d = Math.floor(tenths / 36000);
  const m = Math.floor((tenths % 36000) / 600);
  const s = ((tenths % 600) / 10).toFixed(1);
  return `${d}°${String(m).padStart(2, "0")}'${s.padStart(4, "0")}"${v >= 0 ? pos : neg}`;
};
export const fmtDms = (lat, lng) => `${dms(lat, "N", "S")} ${dms(lng, "E", "W")}`;
const copy = async (txt) => {
  try { await navigator.clipboard.writeText(txt); toast.success("Coordinate copiate"); } catch { toast.error("Copia non riuscita"); }
};

const Line = ({ label, value, testid }) => (
  <div className="flex items-center gap-2">
    <div className="flex-1 min-w-0">
      <div className="text-[10px] font-semibold uppercase tracking-wider" style={{ color: "var(--text-muted)" }}>{label}</div>
      <div className="font-mono text-sm font-semibold break-all" data-testid={testid}>{value}</div>
    </div>
    <button onClick={() => copy(value)} className="p-1.5 rounded hover:bg-black/5" title="Copia" data-testid={`${testid}-copy`}><Copy className="w-4 h-4" /></button>
  </div>
);

export const CoordinateCard = ({ lat, lng, onApply }) => {
  const [edit, setEdit] = useState(false);
  const [la, setLa] = useState("");
  const [ln, setLn] = useState("");
  useEffect(() => { setLa(lat ?? ""); setLn(lng ?? ""); }, [lat, lng]);
  if (lat == null || lng == null) return null;
  const dec = `${Number(lat).toFixed(6)}, ${Number(lng).toFixed(6)}`;

  const apply = () => {
    const a = parseFloat(String(la).replace(",", ".")), b = parseFloat(String(ln).replace(",", "."));
    if (!(a >= -90 && a <= 90) || !(b >= -180 && b <= 180)) { toast.error("Coordinate non valide"); return; }
    setEdit(false);
    onApply(a, b);
  };

  return (
    <div className="card-shell p-4 space-y-3" data-testid="coordinate-card">
      <div className="flex items-center gap-2">
        <MapPin className="w-4 h-4" style={{ color: "var(--primary)" }} />
        <div className="text-xs font-semibold uppercase tracking-wider flex-1" style={{ color: "var(--text-muted)" }}>Coordinate abitazione</div>
        {!edit && <button onClick={() => setEdit(true)} className="p-1.5 rounded hover:bg-black/5" title="Correggi a mano" data-testid="coord-edit"><Pencil className="w-3.5 h-3.5" /></button>}
      </div>
      {edit ? (
        <div className="space-y-2">
          <div className="grid grid-cols-2 gap-2">
            <input value={la} onChange={(e) => setLa(e.target.value)} placeholder="Latitudine" inputMode="decimal" className="px-2 py-1.5 text-sm font-mono rounded-md border" style={{ borderColor: "var(--border)" }} data-testid="coord-lat-input" />
            <input value={ln} onChange={(e) => setLn(e.target.value)} placeholder="Longitudine" inputMode="decimal" className="px-2 py-1.5 text-sm font-mono rounded-md border" style={{ borderColor: "var(--border)" }} data-testid="coord-lng-input" />
          </div>
          <div className="flex gap-2">
            <button onClick={apply} className="btn-primary flex-1 justify-center text-xs" data-testid="coord-apply"><Check className="w-3.5 h-3.5" /> Applica e rianalizza</button>
            <button onClick={() => setEdit(false)} className="btn-secondary text-xs" data-testid="coord-cancel"><X className="w-3.5 h-3.5" /></button>
          </div>
        </div>
      ) : (
        <>
          <Line label="Decimali (lat, long)" value={dec} testid="coord-decimal" />
          <Line label="Gradi · minuti · secondi" value={fmtDms(lat, lng)} testid="coord-dms" />
          <div className="grid grid-cols-2 gap-2">
            <a href={`https://www.google.com/maps/search/?api=1&query=${lat},${lng}`} target="_blank" rel="noreferrer" className="btn-secondary justify-center text-xs" data-testid="coord-open-maps"><ExternalLink className="w-3.5 h-3.5" /> Google Maps</a>
            <a href={`https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`} target="_blank" rel="noreferrer" className="btn-secondary justify-center text-xs" data-testid="coord-navigate"><Navigation className="w-3.5 h-3.5" /> Naviga qui</a>
          </div>
        </>
      )}
    </div>
  );
};
